import React from 'react';

export default function PortalPay() {
  return (
    <section id="portalpay" className="portalpay">
      <div className="container pp-grid">
        <div className="pp-text">
          <div className="eyebrow">Seu financeiro, resolvido</div>
          <h2>O PortalPay Integra direto com banco</h2>
          <p className="lead">Emissão de cobranças, assinaturas recorrentes, segunda via de boleto e histórico completo — tudo dentro do mesmo painel onde você já gerencia seus clientes e rastreadores.</p>
          <div className="pp-features">
            <div className="pp-feature">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
              <span>Cobranças automáticas, sem planilha e sem cobrar cliente um por um</span>
            </div>
            <div className="pp-feature">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
              <span>Assinaturas recorrentes configuradas uma vez só</span>
            </div>
            <div className="pp-feature">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
              <span>Histórico e relatórios financeiros por cliente</span>
            </div>
            <div className="pp-feature">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
              <span>Integrado com Asaas hoje — mais formas de pagamento a caminho</span>
            </div>
          </div>
          <p className="pp-note">A plataforma está em constante evolução — novas integrações de pagamento entram conforme a demanda dos parceiros.</p>
        </div>

        <div className="pp-mock" aria-hidden="true">
          <div className="pp-mock-top">
            <span className="pp-mock-title">PortalPay</span>
            <span className="pp-mock-tag">suamarca.nivocar.com.br</span>
          </div>
          <div className="pp-mock-stats">
            <div className="pp-mock-stat">
              <div className="pp-mock-stat-label">A receber</div>
              <div className="pp-mock-stat-value">R$ 2.340,00</div>
            </div>
            <div className="pp-mock-stat">
              <div className="pp-mock-stat-label">Recebido no mês</div>
              <div className="pp-mock-stat-value">R$ 8.910,00</div>
            </div>
          </div>
          <div className="pp-mock-rows">
            <div className="pp-mock-row"><span>Iva Luis</span><span className="pp-mock-status ok">PAGO</span></div>
            <div className="pp-mock-row"><span>Uelinton Cunha</span><span className="pp-mock-status ok">PAGO</span></div>
            <div className="pp-mock-row"><span>Edivan Bonfim </span><span className="pp-mock-status warn">PENDENTE</span></div>
            <div className="pp-mock-row"><span>José Evandro </span><span className="pp-mock-status ok">PAGO</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}
